module.exports = __webpack_public_path__ + "img/D202011_3.33ed91de.jpg";